import b1 from './boyspfp/b1.png';
import b2 from './boyspfp/b2.png';
import b3 from './boyspfp/b3.png';
import b4 from './boyspfp/b4.png';
import b5 from './boyspfp/b5.png';
import b6 from './boyspfp/b6.png';
import b7 from './boyspfp/b7.png';
import b8 from './boyspfp/b8.png';

function Boyspfp(props:any){
let itemimg = b1;
let iwth = props.wth;
let iht = props.hgt;
//alert(props.itp);
if(props.itemid == 1) itemimg = b1;
else if(props.itemid == 2) itemimg = b2;
else if(props.itemid == 3) itemimg = b3;
else if(props.itemid == 4) itemimg = b4;
else if(props.itemid == 5) itemimg = b5;
else if(props.itemid == 6) itemimg = b6;
else if(props.itemid == 7) itemimg = b7;
else if(props.itemid == 8) itemimg = b8;

//alert(props.itemid);
return(
<div className="per100">
	<div>
        
	<img style={{width:iwth,height:iht}} src={itemimg} className="c-pfp-img" />

	</div>		
		
 </div>
);
}
export default Boyspfp;
